
import React from "react";

const ProgressSteps = () => {
  return (
    <div className="flex items-center gap-3 mb-12">
      {[1, 2, 3, 4, 5].map((step) => (
        <div
          key={step}
          className={`w-10 h-10 rounded-full flex items-center justify-center border-2 
            ${step === 5
              ? "border-gebeya-pink bg-white text-gebeya-pink"
              : step < 5
              ? "border-gebeya-pink bg-gebeya-pink text-white"
              : "border-gray-200 text-gray-400"
            }`}
        >
          {step < 5 ? (
            <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          ) : (
            step
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressSteps;
